<template>
  <div>
    <CCard class="bg-style2" style="border-radius: 0.25rem">
      <CCardBody class="bg-secondary" >
        <!-- 🔹 ปุ่มกลับไปหน้า AI Report -->
        <CRow class="mb-3" v-if="showInternalHeader">
          <CCol>
            <!-- Header -->
            <div class="chat-header">
              <div class="header-content">
                <h2 class="chat-title">แบบฟอร์มแจ้งเหตุ</h2>
                <div v-if="showChatSwitch" class="header-buttons">
                  <CButton class="switch-btn" @click="$emit('switchView', 'ReportChat')">
                    แบบแชท
                  </CButton>
                </div>
              </div>
            </div>
          </CCol>
        </CRow>

        <!-- ส่วนอื่น ๆ ของฟอร์ม -->
        <CRow class="mt-2">
          <CCol>
            <CSelect
              class="c-label required-field"
              label="ประเภทผู้แจ้ง"
              :options="options && options.type ? options.type : []"
              :value="select.userType"
              @input="onUserTypeChange"
              :disabled="loadingUserType"
              required
            />
          </CCol>
          <CCol>
            <CSelect
              class="required-field"
              label="ประเภทภัยพิบัติ"
              :options="options && options.disasterTypes ? options.disasterTypes : []"
              :value="select.disasterType"
              @input="onDisasterTypeChange"
              :disabled="loadingDisasterType"
              required
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CInput
              class="required-field"
              label="ชื่อผู้แจ้ง"
              v-model="form.name"
              required
            />
          </CCol>
          <CCol>
            <CInput
              class="required-field"
              label="เบอร์ติดต่อ"
              type="tel"
              v-model="phoneInput"
              maxlength="10"
              @keypress="onPhoneKeypress"
              required
            />
          </CCol>
        </CRow>
        <CRow class="mb-3">
          <CCol col="12">

            <CInput
              class="required-field"
              label="รายละเอียด"
              v-model="form.description"
              type="textarea"
              rows="4"
              required
            />
            <div class="mt-2">
              <label>อัปโหลดรูปภาพ (สูงสุด 1 รูป, ขนาดไม่เกิน 5MB) : </label>
              <input
                type="file"
                accept="image/*"
                multiple
                @change="onMediaChange"
                :disabled="media.length >= 1"
              />
              <div v-if="media.length" class="media-preview-list mt-2">
                <div v-for="(img, idx) in media" :key="idx" class="media-preview-item" style="display:inline-block; margin-right:8px; position:relative;">
                  <img v-if="isFile(img)" :src="getObjectURL(img)" :alt="'รูปที่ '+(idx+1)" style="width:84px; height:84px; object-fit:cover; border-radius:8px; border:1px solid #ccc;" />
                  <div v-else style="color:red; font-size:0.9em;">ไม่สามารถแสดงรูปนี้ได้</div>
                  <button @click="removeMedia(idx)" style="position:absolute;top:2px;right:2px;background:rgba(0,0,0,0.55);color:#fff;border:none;border-radius:50%;width:22px;height:22px;cursor:pointer;">&times;</button>
                </div>
              </div>
            </div>
          </CCol>
        </CRow>

        <CRow>
          <CCol>
            <CInput
              class="c-label required-field"
              label="สถานที่เกิดเหตุ"
              placeholder="อาคาร ห้อง หรือตำแหน่งที่เกิดเหตุ"
              v-model="form.location"
            />
          </CCol>
        </CRow>

        <CDropdownDivider/>
        <CRow class="text-right mt-3">
          <CCol>
            <CButton class="mr-1" size="sm" color="danger" shape="pill" variant="outline" @click="handleClose">
              <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-ban"/> CANCEL </span>
            </CButton>
            <CButton
              size="sm"
              color="success"
              shape="pill"
              variant="outline"
              @click="onSubmit"
              :disabled="isSubmitting || !isFormValid"
            >
              <span class="font-weight-bold pr-1 pl-1">
                <CIcon name="cil-save"/>
                <span v-if="isSubmitting"><CSpinner size="sm" color="light" /> กำลังส่ง...</span>
                <span v-else>SUBMIT</span>
              </span>
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import QEditor from "@/projects/components/Util/QEditor.vue";
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.snow.css'

import Vue from 'vue'
import Multiselect from "vue-multiselect";
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Swal from 'sweetalert2'
import { CIcon } from '@coreui/icons-vue'
import axios from 'axios'
Vue.use(VueQuillEditor)

export default {
  name: 'ReportForm',
  components: {Multiselect, QEditor, CIcon},
  props: {
    // ถ้า false จะไม่แสดงปุ่ม "แบบแชท" (เช่น เมื่อเรียกจาก CDisasters)
    showChatSwitch: {
      type: Boolean,
      default: true
    },
    // ถ้า false จะไม่แสดงหัวข้อภายในการ์ด (ใช้ title ของ CModal แทน เช่น ใน CDisasters)
    showInternalHeader: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isSubmitting: false,
    }
  },
  computed: {
    ...mapGetters({
      options: 'ReportForm/options',
      selectStore: 'ReportForm/select',
      formStore: 'ReportForm/form',
      media: 'ReportForm/media',
      statusId: 'ReportForm/statusId',
      levelId: 'ReportForm/levelId',
      lat: 'ReportForm/lat',
      lng: 'ReportForm/lng',
      loadingUserType: 'ReportForm/loadingUserType',
      loadingDisasterType: 'ReportForm/loadingDisasterType',
    }),
    select: {
      get() { return this.selectStore },
      set(val) { this.$store.commit('ReportForm/setSelect', val) }
    },
    form: {
      get() { return this.formStore },
      set(val) { this.$store.commit('ReportForm/setForm', val) }
    },
    phoneInput: {
      get() {
        return (this.form && this.form.phone) || '';
      },
      set(val) {
        const digitsOnly = (val || '').toString().replace(/\D/g, '').slice(0, 10);
        this.form = {
          ...this.form,
          phone: digitsOnly,
        };
      }
    },
    isFormValid() {
      const name = this.form && this.form.name;
      const phoneRaw = this.form && this.form.phone;
      const description = this.form && this.form.description;
      const location = this.form && this.form.location;

      const phone = (phoneRaw || '').toString().replace(/\s+/g, '');
      const phoneRegex = /^\d{1,10}$/;

      const hasUserType = !!this.select.userType;
      const hasDisasterType = !!this.select.disasterType;

      return !!(
        name &&
        description &&
        location &&
        phoneRegex.test(phone) &&
        hasUserType &&
        hasDisasterType &&
        this.statusId &&
        this.levelId
      );
    },
  },
  async mounted() {
    await this.$store.dispatch('ReportForm/fetchUserTypes')
    await this.$store.dispatch('ReportForm/fetchDisasterTypes')
    await this.$store.dispatch('ReportForm/fetchStatus')
    await this.$store.dispatch('ReportForm/fetchLevel')
    
    // ตั้งค่าเริ่มต้นสำหรับ dropdown หลังจาก fetch เสร็จแล้ว
    if (this.options && this.options.type && this.options.type.length > 0) {
      const firstUserType = this.options.type[0];
      // ตั้งค่าเป็น value (ID) โดยตรง
      this.$store.commit('ReportForm/setSelect', { 
        userType: firstUserType.value 
      });
    }
    if (this.options && this.options.disasterTypes && this.options.disasterTypes.length > 0) {
      const firstDisasterType = this.options.disasterTypes[0];
      // ตั้งค่าเป็น value (ID) โดยตรง
      this.$store.commit('ReportForm/setSelect', { 
        disasterType: firstDisasterType.value 
      });
    }
    
    // fetch levels, status, location ตาม logic เดิม (เพิ่ม action ใน store ได้)
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        pos => {
          this.$store.commit('ReportForm/setLat', pos.coords.latitude)
          this.$store.commit('ReportForm/setLng', pos.coords.longitude)
        },
        err => {
          this.$store.commit('ReportForm/setLat', null)
          this.$store.commit('ReportForm/setLng', null)
        }
      );
    }
  },

  created() {
  },

  beforeDestroy() {

  },

  methods: {

    goBackToAIReport() {
      this.$router.push('/report');
    },
    isFile(obj) {
      try {
        return typeof File === 'function' && obj instanceof File;
      } catch (e) {
        return false;
      }
    },
    getObjectURL(file) {
      return (window.URL && file) ? window.URL.createObjectURL(file) : '';
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    async compressImage(file, maxSize) {
      return new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();
        
        img.onload = () => {
          // Calculate new dimensions (maintain aspect ratio)
          let { width, height } = img;
          const maxDimension = 1024; // Max width/height
          
          if (width > height && width > maxDimension) {
            height = (height * maxDimension) / width;
            width = maxDimension;
          } else if (height > maxDimension) {
            width = (width * maxDimension) / height;
            height = maxDimension;
          }
          
          canvas.width = width;
          canvas.height = height;
          
          // Draw and compress
          ctx.drawImage(img, 0, 0, width, height);
          
          // Try different quality levels
          let quality = 0.8;
          let compressedFile;
          
          const tryCompress = () => {
            canvas.toBlob((blob) => {
              if (blob.size <= maxSize || quality <= 0.1) {
                compressedFile = new File([blob], file.name, {
                  type: 'image/jpeg',
                  lastModified: Date.now()
                });
                resolve(compressedFile);
              } else {
                quality -= 0.1;
                tryCompress();
              }
            }, 'image/jpeg', quality);
          };
          
          tryCompress();
        };
        
        img.onerror = reject;
        img.src = URL.createObjectURL(file);
      });
    },
    async onMediaChange(e) {
      const files = Array.from(e.target.files);
       // จำกัดจำนวนรูปสูงสุด 1 รูป
      if (this.media.length + files.length > 1) {
        Swal.fire({
          icon: 'warning',
          title: 'จำนวนรูปเกินขีดจำกัด',
          text: 'อัปโหลดได้สูงสุด 1 รูปเท่านั้น',
          confirmButtonText: 'ตกลง'
        });
        e.target.value = '';
        return;
      }
      
      for (let file of files) {
        if (!file.type.startsWith('image/')) continue;
        const targetSize = 1 * 1024 * 1024; // 1MB target for ReportForm

        // บีบอัดทุกไฟล์ให้ต่ำกว่า 1MB
        if (file.size > targetSize) {
          try {
            Swal.fire({
              icon: 'info',
              title: 'กำลังบีบอัดรูปภาพให้ต่ำกว่า 1MB...',
              text: 'กรุณารอสักครู่',
              allowOutsideClick: false,
              showConfirmButton: false
            });
            file = await this.compressImage(file, targetSize);
            Swal.close();
            Swal.fire({
              icon: 'success',
              title: 'บีบอัดรูปภาพสำเร็จ!',
              timer: 1500,
              showConfirmButton: false
            });
          } catch (error) {
            Swal.close();
            Swal.fire({
              icon: 'error',
              title: 'ไม่สามารถบีบอัดไฟล์ได้',
              text: 'กรุณาเลือกรูปที่มีขนาดไม่เกิน 1MB',
              confirmButtonText: 'ตกลง'
            });
            continue;
          }
        }

        this.$store.commit('ReportForm/addMedia', file);
      }
      
      e.target.value = '';
    },
    removeMedia(index) {
      this.$store.commit('ReportForm/removeMedia', index);
    },

    onUserTypeChange(val) {
      let userType = '';
      if (val && val.target && val.target.value) {
        userType = val.target.value;
      } else if (val && val.value) {
        userType = val.value;
      } else if (typeof val === 'string') {
        userType = val;
      } else if (Array.isArray(val) && val[0] && val[0].value) {
        userType = val[0].value;
      }
      this.$store.commit('ReportForm/setSelect', { userType });
    },
    onDisasterTypeChange(val) {
      let disasterType = '';
      if (val && val.target && val.target.value) {
        disasterType = val.target.value;
      } else if (val && val.value) {
        disasterType = val.value;
      } else if (typeof val === 'string') {
        disasterType = val;
      } else if (Array.isArray(val) && val[0] && val[0].value) {
        disasterType = val[0].value;
      }
      this.$store.commit('ReportForm/setSelect', { disasterType });
    },

    onPhoneKeypress(event) {
      const char = event.key;
      // อนุญาตเฉพาะตัวเลข 0-9 เท่านั้น
      if (!/[0-9]/.test(char)) {
        event.preventDefault();
      }
    },

    async onSubmit(){
      if (this.isSubmitting) return;

      console.log('Debug - select.userType:', this.select.userType);
      console.log('Debug - select.disasterType:', this.select.disasterType);
      
      // ตรวจสอบประเภทผู้แจ้ง
      let userType = this.select.userType;
      if (typeof userType === 'object' && userType && userType.value) {
        userType = userType.value;
      } else if (typeof userType === 'object' && userType && userType.label) {
        userType = userType.label;
      }
      console.log('Debug - processed userType:', userType);
      if (!userType) {
        await Swal.fire({
          icon: 'warning',
          title: 'กรุณาเลือกประเภทผู้แจ้ง',
          confirmButtonText: 'ตกลง'
        });
        return;
      }
      
      // ตรวจสอบประเภทภัยพิบัติ
      let disasterType = this.select.disasterType;
      if (typeof disasterType === 'object' && disasterType && disasterType.value) {
        disasterType = disasterType.value;
      } else if (typeof disasterType === 'object' && disasterType && disasterType.label) {
        disasterType = disasterType.label;
      }
      console.log('Debug - processed disasterType:', disasterType);
      if (!disasterType) {
        await Swal.fire({
          icon: 'warning',
          title: 'กรุณาเลือกประเภทภัยพิบัติ',
          confirmButtonText: 'ตกลง'
        });
        return;
      }

      const name = this.form && this.form.name;
      const phoneRaw = this.form && this.form.phone;
      const description = this.form && this.form.description;

      if (!name || !phoneRaw || !description || !location) {
        await Swal.fire({
          icon: 'warning',
          title: 'กรุณากรอกข้อมูลให้ครบถ้วน',
          text: 'กรุณากรอก ชื่อผู้แจ้ง เบอร์ติดต่อ รายละเอียด และสถานที่เกิดเหตุ ให้ครบ',
          confirmButtonText: 'ตกลง'
        });
        return;
      }

      const phone = phoneRaw.toString().replace(/\s+/g, '');
      const phoneRegex = /^\d{1,10}$/;
      if (!phoneRegex.test(phone)) {
        await Swal.fire({
          icon: 'warning',
          title: 'รูปแบบเบอร์ติดต่อไม่ถูกต้อง',
          text: 'กรุณากรอกเบอร์โทรให้เป็นตัวเลข ไม่เกิน 10 หลัก',
          confirmButtonText: 'ตกลง'
        });
        return;
      }

      if (!this.statusId) {
        await Swal.fire({
          icon: 'error',
          title: 'ไม่สามารถดึงสถานะเริ่มต้นได้',
          text: 'กรุณารีเฟรชหน้า แล้วลองใหม่อีกครั้ง',
          confirmButtonText: 'ตกลง'
        });
        return;
      }
      if (!this.levelId) {
        await Swal.fire({
          icon: 'error',
          title: 'ไม่สามารถดึงระดับความรุนแรงเริ่มต้นได้',
          text: 'กรุณารีเฟรชหน้า แล้วลองใหม่อีกครั้ง',
          confirmButtonText: 'ตกลง'
        });
        return;
      }

      this.isSubmitting = true;
      const locationPayload = { address: this.form.location };
      if (this.lat !== null && this.lng !== null) {
        locationPayload.coordinates = [this.lng, this.lat];
      } else {
        locationPayload.coordinates = [0, 0];
      }
      const formData = new FormData();
      
      // หา label จาก value ที่เลือก
      let disasterTypeLabel = disasterType;
      let userTypeLabel = userType;
      
      // ถ้า disasterType เป็น ID ให้หา label
      if (this.options && this.options.disasterTypes) {
        const selectedDisaster = this.options.disasterTypes.find(d => d.value === disasterType);
        if (selectedDisaster && selectedDisaster.label) {
          disasterTypeLabel = selectedDisaster.label;
        }
      }
      
      // ถ้า userType เป็น ID ให้หา label
      if (this.options && this.options.type) {
        const selectedUser = this.options.type.find(u => u.value === userType);
        if (selectedUser && selectedUser.label) {
          userTypeLabel = selectedUser.label;
        }
      }
      
      console.log('Sending disasterTypeLabel:', disasterTypeLabel);
      console.log('Sending userTypeLabel:', userTypeLabel);
      
      formData.append('type', disasterTypeLabel);
      formData.append('user', userTypeLabel);
      formData.append('description', this.form.description);
      formData.append('location', JSON.stringify(locationPayload));
      formData.append('contact', JSON.stringify({
        name: name,
        phone: phone
      }));
      formData.append('status', this.statusId);
      formData.append('level', this.levelId);
      formData.append('intent', 'report');
      if (this.media && this.media.length > 0) {
        this.media.forEach((img) => {
          if (this.isFile(img)) {
            formData.append('media', img);
          }
        });
      }
      for (let pair of formData.entries()) {
        console.log(pair[0]+ ':', pair[1]);
      }
      // SweetAlert loading
      Swal.fire({
        title: 'กำลังส่งข้อมูล...',
        html: '<div style="font-size:1.1rem;">เรากำลังส่งข้อมูลของคุณไปยังเจ้าหน้าที่</div>',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => { Swal.showLoading(); }
      });
      try {
        //http://localhost:8081/api/v1/report/report,https://sos.mfu.ac.th/api/v1/report/report
        const res = await axios.post('https://sos.mfu.ac.th/api/v1/report/report', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        Swal.close();
        const result = res.data;
        if (
          result.code === 20000 ||
          result.success === true ||
          result.status === 'success' ||
          (result.data && result.data._id)
        ) {
          await Swal.fire({
            icon: 'success',
            title: 'รายงานของคุณถูกส่งเรียบร้อยแล้ว',
            showConfirmButton: true,
            confirmButtonText: 'ตกลง'
          });
          await Swal.fire({
            icon: 'info',
            title: 'เจ้าหน้าที่กำลังดำเนินการ',
            html: '<div style="font-size:1.1rem;">โปรดรอสักครู่ เจ้าหน้าที่จะติดต่อกลับโดยเร็วที่สุด</div>',
            showConfirmButton: false,
            showCloseButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            willOpen: () => { Swal.showLoading() }
          });
          this.$store.commit('ReportForm/resetForm');
        } else {
          await Swal.fire('เกิดข้อผิดพลาด', result.message || JSON.stringify(result) || 'ไม่สามารถส่งรายงานได้', 'error');
        }
      } catch (e) {
        Swal.close();
        await Swal.fire('เกิดข้อผิดพลาด', 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์', 'error');
      } finally {
        this.isSubmitting = false;
      }
    },

    selectStyle(opt) {
      this.select.levels = opt.value;
    },


    handleClose() {
        this.$store.commit("dialog/isDisaters", false)
    }

  },

  watch: {

  }
}
</script>

<style scoped>
CCardBody {
  min-height: 65vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.chat-header {
  text-align: left;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.header-buttons {
  margin-left: auto;
}



::v-deep .required-field label::after {
  content: " *";
  color: red;
}

@media (max-width: 900px) {
  CCardBody {
    min-height: 50vh;
    padding: 1.2rem 0.5rem 1rem 0.5rem;
  }
}
</style>
